const STORAGE_KEY = "featureFlagsConfig";

export function createLocalStorageRepository() {
  return {
    getState: (): Record<string, boolean> => {
      try {
        const storedConfig = localStorage.getItem(STORAGE_KEY);
        return storedConfig ? JSON.parse(storedConfig) : {};
      } catch (error) {
        console.error("Error reading from localStorage:", error);
        return {};
      }
    },
    setState: (config: Record<string, boolean>): void => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
      } catch (error) {
        console.error("Error writing to localStorage:", error);
      }
    },
  };
}
